// Client V2 common imports
const {
  ARTICLE_DOMAIN_BLOCKED,
  ARTICLES_REPORTED
} = require('client-v2/common/models/article/actions')
// Sibling imports
const {
  HIDE,
  NEXT_PAGE_LOADED,
  NEXT_PAGE_LOADING,
  SET_CURRENT_INDEX,
  SHOW
} = require('./modal-actions')
const ArticleProfileModalRecord = require('./modal-record')
const articleProfileSlideReducer = require('./slide-reducer')

/* eslint-disable complexity */
function articleProfileModalReducer(state = null, action) {
  const { type, payload } = action
  if (!state && type !== SHOW) {
    return null
  }
  switch (type) {
    case HIDE:
      return null
    case SHOW:
      return (state || new ArticleProfileModalRecord).setup(payload)
    case SET_CURRENT_INDEX:
      return state.setCurrentIndex(payload.currentIndex)
    case NEXT_PAGE_LOADING:
      return state.setNextPageLoading()
    case NEXT_PAGE_LOADED:
      return state.setNextPageLoaded(payload)
    case ARTICLE_DOMAIN_BLOCKED: {
      const nextState = state.removeSlidesByHostname(payload.hostname)
      return articleProfileModalSlidesReducer(nextState, action)
    }
    case ARTICLES_REPORTED: {
      const nextState = state.removeSlidesByUrlIds(payload.urlIds)
      return articleProfileModalSlidesReducer(nextState, action)
    }
    default:
      return articleProfileModalSlidesReducer(state, action)
  }
}

function articleProfileModalSlidesReducer(state, action) {
  return state.update('slides', slides => {
    let slidesModified = false
    const newSlides = slides.map(slide => {
      const newSlide = articleProfileSlideReducer(slide, action)
      slidesModified = slidesModified || (slide !== newSlide)
      return newSlide
    })
    return slidesModified ? newSlides : slides
  })
}
/* eslint-enable complexity */

module.exports = articleProfileModalReducer
